import { Chip } from '@mui/material';

import { useSyncedCountFromStorage } from '@containers/unallocated-installations/table/hooks/useSyncedCountFromStorage';
import { LocalStorageKey } from '@tools/enums/local-storage-key';

import styles from '@components/menu/index.module.scss';

export const MenuLabelUnallocatedInstallations = () => {
    const syncedCount = useSyncedCountFromStorage(
        LocalStorageKey.UNALLOCATED_INSTALLATIONS_COUNT,
    );

    if (syncedCount === null || syncedCount < 1) return null;

    return (
        <Chip
            label={syncedCount}
            size="small"
            className={`${styles.item__chip} ${styles['item__chip--dark']}`}
        />
    );
};
